import { css } from '@emotion/css';

export const setGap = (gap: number) => css`
  gap: ${gap / 10}rem;
`;

export const setGapX = (gap: number) => css`
  column-gap: ${gap / 10}rem;
`;

export const setGapY = (gap: number) => css`
  row-gap: ${gap / 10}rem;
`;
